<template>
    <li>
        <div class="relative pb-8">
            <span v-if="!last" class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
            <div class="relative flex space-x-3">
                <div>
                    <span v-if="item.status === 200" class="h-8 w-8 rounded-full bg-green-500 flex items-center justify-center ring-8 ring-white">
                        <!-- Heroicon name: solid/check -->
                        <svg class="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                    </span>
                    <span v-else class="h-8 w-8 rounded-full bg-red-500 flex items-center justify-center ring-8 ring-white">
                        <!-- Heroicon name: solid/check -->
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>
                </div>
                <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                    <div>
                        <p class="text-sm text-gray-500"> {{ item.url }} </p>
                        <p v-if="item.response" class="text-sm text-gray-500"> Response: {{ item.response }} </p>
                    </div>
                    <div class="text-right text-sm whitespace-nowrap text-gray-500">
                        <span> {{ time }} </span>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: "TimelineItem",
    props: ['item', 'last'],
    methods: {
        timeSince(date) {
            let seconds = Math.floor((new Date() - date) / 1000);

            let interval = seconds / 31536000;

            let result;

            if (interval > 1) {
                result = Math.floor(interval);
                if( result === 1 ) return result + ' rok';
                else if( result < 5 ) return result + ' roky';
                else return result + ' let';
            }
            interval = seconds / 2592000;
            if (interval > 1) {
                result = Math.floor(interval);
                if( result === 1 ) return result + ' měsíc';
                else if( result < 5 ) return result + ' měsíce';
                else return result + ' měsíců';
            }
            interval = seconds / 86400;
            if (interval > 1) {
                result = Math.floor(interval);
                if( result === 1 ) return result + ' den';
                else if( result < 5 ) return result + ' dny';
                else return result + ' dnů';
            }
            interval = seconds / 3600;
            if (interval > 1) {
                result = Math.floor(interval);
                if( result === 1 ) return result + ' hodina';
                else if( result < 5 ) return result + ' hodiny';
                else return result + ' hodin';
            }
            interval = seconds / 60;
            if (interval > 1) {
                result = Math.floor(interval);
                if( result === 1 ) return result + ' minuta';
                else if( result < 5 ) return result + ' minuty';
                else return result + ' minut';
            }
            result = Math.floor(interval);
            if( result <= 1 ) return 'právě teď';
            else if( result < 5 ) return result + ' sekundy';
            else return result + ' sekund';
        }
    },
    computed: {
        time: function () {
            return this.timeSince(new Date(this.$props.item.created_at));
        }
    }
}
</script>

<style scoped>

</style>
